<template>
    <BasePopUp v-if="showModal" @detailsClosed="closeConfirmRequested">
        <div v-if="order" class="modal-body-container">
            <!-- Title -->
            <h4 class="text-center mt-4">{{ $t('orderDetail') }}</h4>
            <div class="d-flex flex-wrap">
                <!-- Id -->
                <label class="col-12 font-weight-bold">ID</label>
                <span class="col-12">{{order.id}}</span>
                <!-- Id Stripe -->
                <label class="col-12 font-weight-bold">ID Stripe</label>
                <span class="col-12">{{order.info}}</span>
                <!-- Date -->
                <label class="col-12 font-weight-bold">Date</label>
                <span class="col-12">{{order.readableDate}}</span>
                <!-- Status -->
                <label class="col-12 font-weight-bold">Status</label>
                <span class="col-12">{{order.readableStatus}}</span>
                <!-- User details -->
                <label class="col-12 font-weight-bold">User details</label>
                <span class="col-6">First name</span>
                <span class="col-6 text-right">{{order.details.firstName}}</span>
                <div class="col-12 p-0"><hr/></div>
                <span class="col-6">Last name</span>
                <span class="col-6 text-right">{{order.details.lastName}}</span>
                <div class="col-12 p-0"><hr/></div>
                <span class="col-6">Contact number</span>
                <span class="col-6 text-right">{{order.details.phoneNumber}}</span>
                <div class="col-12 p-0"><hr/></div>
                <span class="col-6">Email</span>
                <span class="col-6 text-right">{{order.details.email}}</span>
                <div class="col-12 p-0"><hr/></div>
                <span class="col-6">Nationality</span>
                <span class="col-6 text-right">{{order.details.nationality}}</span>
                <div class="col-12 p-0"><hr/></div>
                <span class="col-6">VAT</span>
                <span class="col-6 text-right">{{order.details.vat}}</span>
                <div class="col-12 p-0"><hr/></div>
                <span class="col-6">Billing address</span>
                <span class="col-6 text-right">{{order.details.billingAddress}}</span>
                <div class="col-12 p-0"><hr/></div>
                <span class="col-6">ZIP Code</span>
                <span class="col-6 text-right">{{order.details.zipCode}}</span>
                <div class="col-12 p-0"><hr/></div>
                <span class="col-6">City</span>
                <span class="col-6 text-right">{{order.details.city}}</span>
                <div class="col-12 p-0"><hr/></div>
                <span class="col-6">Country</span>
                <span class="col-6 text-right">{{order.details.country}}</span>
                <div class="col-12 p-0" v-if="order.details.otherInfo"><hr/></div>
                <span class="col-6" v-if="order.details.otherInfo">Other info</span>
                <span class="col-6 text-right" v-if="order.details.otherInfo">{{order.details.otherInfo}}</span>
                <!-- Products -->
                <label class="col-12 font-weight-bold">Products</label>
                <div class="col-12 d-flex flex-wrap p-0" v-for="(product, index) in order.products" :key="index">
                    <span class="col-6">{{product.title}} ({{product.type}}) x{{product.quantity}}</span>
                    <span class="col-6 text-right">{{product.price}}€ ({{product.finalPrice}}€)</span>
                    <div v-if="index + 1 < order.products.length" class="col-12 p-0"><hr/></div>
                </div>
                <!-- Total -->
                <label class="col-12 font-weight-bold">Total</label>
                <span class="col-12">{{totalPrice}}€ ({{finalTotalPrice}}€)</span>
            </div>
            <!-- Button -->
            <CButton type="button" class="mb-4 btn btn-primary align-self-center" @click="closeConfirmRequested">{{ $t('close') }}</CButton>
        </div>
    </BasePopUp>
</template>

<script>
import BasePopUp from './BasePopUp.vue';

export default {
    extends: BasePopUp,
    components: {BasePopUp},
    methods:{
        closeConfirmRequested()
        {       
            this.$emit("closeConfirmRequested");
        }
    },
    props:{
        order: Object
    },
    computed:
    {
        totalPrice: function()
        {
            let total = 0;

            if(this.order && this.order.products)
            {
                this.order.products.forEach((item) => {
                    total += item.price * item.quantity;
                });
            }
            
            return total.toFixed(2)
        },
        finalTotalPrice: function()
        {
            let total = 0;

            if(this.order && this.order.products)
            {
                this.order.products.forEach((item) => {
                    total += item.finalPrice * item.quantity;
                });
            }
            
            return total.toFixed(2)
        }
    }
}
</script>

<style scoped>
    .modal-body-container
    {
        background-color: #fff;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 10px;
        border-radius: 10px;    
        min-height: 200px;
    
    }

    label
    {
        margin-bottom: 0;
        margin-top: 1rem;
    }
</style>